module.exports = __webpack_public_path__ + "static/media/ww_epf2.0399efaa.gif";